import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStateService } from '../../services/auth-state/auth-state.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const Authorization = 'Authorization';
  const XSecurityToken = 'X-Security-Token';

  // Skip if request already has Authorization header
  const requestHasAuthHeader = req.headers.has(Authorization);
  if (requestHasAuthHeader) {
    return next(req);
  }

  // Get auth service (removed { self: true } to allow proper DI resolution)
  const authStateService = inject(AuthStateService);
  const authHeader = authStateService.getAuthorizationHeader();

  // If no token available, pass request through without auth header
  // (let the backend decide if the endpoint requires auth)
  if (!authHeader) {
    console.debug(
      '[AuthInterceptor] No token available, passing request through'
    );
    return next(req);
  }

  console.debug('[AuthInterceptor] Adding Authorization header');

  const requestHasXSecurityToken = req.headers.has(XSecurityToken);
  if (requestHasXSecurityToken) {
    const authenticatedRequest = req.clone({
      setHeaders: {
        [XSecurityToken]: authHeader,
      },
    });
    return next(authenticatedRequest);
  }

  // add Authorization header if it doesn't exist
  const authenticatedRequest = req.clone({
    withCredentials: true,
    setHeaders: {
      [Authorization]: authHeader,
    },
  });
  return next(authenticatedRequest);
};
